import { Injectable } from '@angular/core';
import { baseUrl, countriesGateway } from './endpoint';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  private url = baseUrl + countriesGateway;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getCountriesData(country: string, date: string): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getCountriesData', item1: country, item2: date })
    .pipe(
      catchError(this.handleError('getCountriesData', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
